import React from "react";
import Navigation from "../../../components/Navigation/Navigation";
import "./About.css";
import FrontendFooter from "../../../components/Layout/FrontendFooter";
import { Container } from "@mui/material";
import Grid from "@mui/material/Grid2";
import AboutMainImage from "../../../assets/images/iron-ore.jpg";
import AboutBanner from "../../../assets/images/about-banner.jpg";


const About = () => {

  
  return (
    <div className="app-container">
      <Navigation />

      <section className="inner-banner text-white" style={{ backgroundImage: `url(${AboutBanner})` }}>
        <div className="home-container">
          <h1 className="page-title">About Us</h1>
          <p>Steelbuddy is a modern digital platform from the renowned Vizag Profiles Group</p>
        </div>
      </section>

      <section className="home-about">
        <Container maxWidth="lg">
          <Grid
            className="home-about-container"
            container
            spacing={2}
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid size={{ xs: 12, md: 5 }} order={{ xs: 1, md: 2 }}>
              <div className="home-about-image">
                <img
                  src="https://www.bharatsteels.in/blog/wp-content/uploads/2021/10/steel.jpg"
                  alt="About Us"
                />
              </div>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }} order={{ xs: 1, md: 2 }}>
              <div className="home-about-content">
                <h2 className="page-title">Who we are</h2>
                <p>
                Steelbuddy is a modern digital platform from the renowned Vizag Profiles Group, created to simplify and enhance the steel trading experience for customers, distributors, and manufacturers alike. The group leveraging over 25 years of excellence in steel handling, trading, and manufacturing, Steelbuddy blends cutting-edge technology with deep industry expertise and a trusted supplier network.
                </p>
                <p>
                Designed to bring convenience, speed, and reliability to steel supply process, Steelbuddy allows users to raise product enquiries seamlessly through its mobile app or website.

                </p>
                
              
              </div>
            </Grid>
          </Grid>






          <Grid
            className="home-about-container"
            container
            spacing={2}
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid size={{ xs: 12, md: 5 }} order={{ xs: 2, md: 2 }}>
              <div className="home-about-image">
                <img
                  src={AboutMainImage}
                  alt="About Us"
                />
              </div>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }} order={{ xs: 1, md: 1 }}>
              <div className="home-about-content">
                <h2 className="page-title">Why Steelbuddy</h2>
                <p>
                Steelbuddy opens the next chapter for VPL Group, carrying decades of excellence into the digital space. Designed to simplify and accelerate the end-to-end steel supply chain, Steelbuddy offers a comprehensive catalog of steel products, instant enquiry and quotation features, real-time notifications to keep you updated at every step and a user-friendly experience tailored for businesses and individuals alike.
                </p>
                <p>
                Steelbuddy is not just another marketplace—it's a smarter, faster, commitment to efficiency, integrity, and putting the power of informed choice directly in your hands.
                </p>
                
              
              </div>
            </Grid>
          </Grid>












        </Container>
      </section>

      <FrontendFooter />
    </div>
  );
};

export default About;
